var map = {
	"./sala-pesi-10.jpg": 248,
	"./sala-pesi-11.jpg": 157,
	"./sala-pesi-2.jpg": 429,
	"./sala-pesi-3.jpg": 64,
	"./sala-pesi-4.jpg": 739,
	"./sala-pesi-5.jpg": 606,
	"./sala-pesi-6.jpg": 665,
	"./sala-pesi-7.jpg": 940,
	"./sala-pesi-9.jpg": 954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 292;